(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-hooks/assets/javascripts/use-bet-event.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-hooks/assets/javascripts/use-bet-event.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.selectors,
  selectEventStatistic = _svs$components$sport.selectEventStatistic,
  selectBetEvent = _svs$components$sport.selectBetEvent;
const _svs$components$sport2 = svs.components.sportinfo.common.helpers,
  createEventStatisticsKey = _svs$components$sport2.createEventStatisticsKey,
  createBetEventKey = _svs$components$sport2.createBetEventKey;
const defaultBetEvent = {
  matchId: undefined,
  eventTypeId: undefined,
  participantIds: undefined
};

const useBetEvent = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    eventNumber = _ref.eventNumber;
  const betEventKey = createBetEventKey(productId, drawNumber, eventNumber);
  const betEvent = useSelector(state => selectBetEvent(state, betEventKey)) || defaultBetEvent;
  const matchId = betEvent.matchId,
    eventTypeId = betEvent.eventTypeId,
    periodNumber = betEvent.periodNumber;
  const eventStatisticsKey = createEventStatisticsKey({
    matchId,
    eventTypeId,
    periodNumber,
    eventNumber
  });
  const eventStatistics = useSelector(state => selectEventStatistic(state, eventStatisticsKey));
  return {
    betEvent,
    betEventKey,
    eventStatistics,
    eventStatisticsKey
  };
};
setGlobal('svs.components.sportinfo.matchInfoHooks.useBetEvent', useBetEvent);

 })(window);